import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import { useEffect, Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { getAnomalyChart } from './anomalyChartApi';
import { Spinner } from "react-bootstrap"


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);
const validatedType = {
    SECURITY: "Безопасность",
    MINOR: "Незначительное",
    BASIC_CONDITION: "Базовое состояние",
    QUALITY: "Качество",
    POLLUTION: "Загрязнение",
    HARD_TO_REACH: "Труднодоступное"
}
export const options = {

    responsive: true,
    maintainAspectRatio: false,
    plugins: [ChartDataLabels],
    scales: {
        x: {
            ticks: {
                color: 'black',
                font: {
                    size: 10,
                },

            }
        }
    }


};

export function AnomalyChart() {

    const log = useSelector((state) => state.login)
    const anomaly = useSelector((state) => state.anomaly)
    const dispatch = useDispatch()
    let navigate = useNavigate();


    useEffect(() => {
        if (!log.token) {
            return navigate("/login");
        }
    })

    let info = (<Fragment>
        <Spinner animation="border" />
    </Fragment>)

    var labels = []
    var openedValues = []
    var closedValues = []
    if (anomaly.chartData != null) {
        labels = anomaly.chartData['opened_count'].map((item) => validatedType[item.name])
        openedValues = anomaly.chartData['opened_count'].map((item) => item.value)
        closedValues = anomaly.chartData['closed_count'].map((item) => item.value)


        var data = {
            labels,
            datasets: [
                {
                    label: 'Открытые аномалии',
                    data: openedValues,
                    backgroundColor: '#F33637',
                },
                {
                    label: 'Закрытые аномалии',
                    data: closedValues,
                    backgroundColor: '#1e87f0',
                }
            ],
        };
        info = (<Fragment><Bar options={options} data={data} /></Fragment>)
    } else {
        setTimeout(() => dispatch(getAnomalyChart(log.token)), 1000);
    }
    return (
    <Fragment>
        <div>
        {info}
        </div>
        </Fragment>)
}
